import baseRequest from './useRequest';
// import { customerFragment }  from '@/hooks/shopify-hooks/fragments/customerFragment';
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import { useSuccessMsgBox } from "@/hooks/common/msg-box/useSuccessMsgBox";
import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { encryptData } from "@/utils/encryption.js"
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useBrand } from "@/hooks/common/useUtils";
const brand = useBrand();
const { domain, countryIsoCode = '', languageIsoCode = 'en' } = shopifyConst;
const languageCode = languageIsoCode.toUpperCase();
const inContext = `, $country: CountryCode!, $language: LanguageCode!)
@inContext(country: $country, language: $language`;

// 登录调用接口
// export const useCreateCustomerAccessToken = async (customerAccessModel) => {
//   try {

//     const query = `
//       mutation CustomerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
//         customerAccessTokenCreate(input: $input) {
//           customerAccessToken {
//             accessToken
//             expiresAt
//           }
//           customerUserErrors {
//             code
//             field
//             message
//           }
//         }
//       }
//     `;
//     const variables = {
//       input: customerAccessModel
//     };
//     const response = await baseRequest(query, variables);

//     if (response?.data?.customerAccessTokenCreate?.customerUserErrors?.length) {
//       const resultMsg = response?.data?.customerAccessTokenCreate?.customerUserErrors[0].message;
//       if (response?.data?.customerAccessTokenCreate?.customerUserErrors[0].code === 'UNIDENTIFIED_CUSTOMER') {
//         // 这种错误抛出去，由组件去显示配置的错误信息
//         throw (new Error('UNIDENTIFIED_CUSTOMER'));
//       } else {
//         useFailMsgBox(resultMsg);
//         throw (new Error(resultMsg));
//       }
//     }

//     console.log('======createCustomerAccessToken======', response)
//     return response?.data.customerAccessTokenCreate;
//   } catch (e) {
//     throw new Error(e);
//   }
// }
export  const useCreateCustomerAccessToken = async (customerAccessModel, validateParams, customOptions) => {
  try {
    const params = {
      email: await encryptData(customerAccessModel.email),
      password: await encryptData(customerAccessModel.password),//需要加密
      validateParams
    }
    const res = await useScrmFetch(`/api/gws-ext/customer/login?endpoint=${domain}`, customOptions).post(params).json();
    if (res?.error && res?.error?.value) {
      useFailMsgBox(res.error.value);
      throw (new Error());
    }
    const response = res.data.value
    if (response?.data?.customerAccessTokenCreate?.customerUserErrors?.length) {
      const resultMsg = response?.data?.customerAccessTokenCreate?.customerUserErrors[0].message;
      if (response?.data?.customerAccessTokenCreate?.customerUserErrors[0].code === 'UNIDENTIFIED_CUSTOMER') {
        // 这种错误抛出去，由组件去显示配置的错误信息
        throw (new Error('UNIDENTIFIED_CUSTOMER'));
      } else {
        useFailMsgBox(resultMsg);
        throw (new Error(resultMsg));
      }
    }
    return response?.data.customerAccessTokenCreate;
  } catch (e) {
    throw new Error(e);
  }
}
// C4Atoken登录
export  const useGetLogin = async (token) => {
  try {
    const params = {
      c4aToken: token,
      endpoint: domain
    }
    const res = await useScrmFetch(`/api/gws-ext/c4a/token/exchange?endpoint=${domain}`).post(params).json();

    return res;
  } catch (e) {
    throw new Error(e);
  }
}

// 注册调用接口，创建customer
// 处理客户创建错误
const handleCustomerCreateError = (response, customOptions, brand, customerInput) => {
  const error = response?.data?.customerCreate?.customerUserErrors[0];
  if (!error?.message) {
    return false;
  }

  const message = customOptions.signUpAccountWaitPrompt.includes('$email')
    ? customOptions.signUpAccountWaitPrompt.replace('$email', customerInput.email)
    : error.message;

  if (error.field === null) {
    if (brand === 'toshiba') {
      useSuccessMsgBox(message);
    } else {
      useFailMsgBox(message);
    }
    throw new Error(message);
  }
  return true;
};

// 处理访问令牌错误
const handleAccessTokenError = (response) => {
  if (!response?.data?.customerAccessTokenCreate?.customerAccessToken) {
    const message = response?.data?.customerAccessTokenCreate?.customerUserErrors[0]?.message;
    if (message) {
      useFailMsgBox(message);
      throw new Error(message);
    }
  }
};

// 加密客户输入数据
const encryptCustomerData = async (customerInput) => {
  return {
    acceptsMarketing: customerInput.acceptsMarketing,
    email: await encryptData(customerInput.email),
    firstName: await encryptData(customerInput.firstName),
    lastName: await encryptData(customerInput.lastName),
    password: await encryptData(customerInput.password),
  };
};

export const customerCreate = async (customerInput, validateParams, customOptions) => {
  try {
    const params = {
      ...(await encryptCustomerData(customerInput)),
      ...(customerInput.locale ? { locale: customerInput.locale } : {}),
      validateParams,
    };

    const res = await useScrmFetch(`/api/gws-ext/customer/register?endpoint=${domain}`, customOptions).post(params).json();

    if (res?.error?.value) {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.signUpFailPrompt,
      });
      throw new Error(res.error.value);
    }

    const response = res.data.value;
    if (!response) {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.signUpFailPrompt,
      });
      throw new Error(res.error?.value || 'Unknown error');
    }

    if (response?.errors?.length) {
      const message = response.errors[0].message;
      useFailMsgBox(message);
      throw new Error(message);
    }

    if (response?.data?.customerCreate?.customerUserErrors[0]?.message) {
      handleCustomerCreateError(response, customOptions, brand, customerInput);
      const message = response.data.customerCreate.customerUserErrors[0].message;
      useFailMsgBox(message);
      throw new Error(message);
    }

    handleAccessTokenError(response);
    return response?.data?.customerAccessTokenCreate;
  } catch (e) {
    throw new Error(e);
  }
};

// 忘记密码调用接口，收回账号
export const customerRecover = async (email, customOptions) => {
  try {
    const query = `      
    mutation customerRecover($email: String!) {
        customerRecover(email: $email) {
            customerUserErrors {
                field
                message
            }
            userErrors {
                field
                message
            }
        }
    }
    `;
    const variables = {
      email: email
    };
    const response = await baseRequest(query, variables);
    if (!response) {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.resetPWFailPrompt,
      });
      throw (new Error());
    }

    if (response?.data?.customerRecover?.customerUserErrors?.length) {
      const resultMsg = response?.data?.customerRecover?.customerUserErrors[0].message
      useFailMsgBox(resultMsg);
      throw (new Error(resultMsg));
    }
    if (response?.errors?.length) {
      const resultMsg = response?.errors[0].message
      useFailMsgBox(resultMsg);
      throw (new Error());
    }else if (response?.errors?.graphQLErrors?.length){
      useFailMsgBox(response?.errors?.graphQLErrors[0].message);
      throw (new Error());
    }else if (response?.errors?.message) {
      useFailMsgBox(response?.errors?.message);
      throw (new Error());
    } else {
      return response;
    }

  } catch (e) {
    throw new Error(e);
  }
}

// 重置密码调用，通过url重置的方式
export const customerResetByUrl = async (password, resetUrl, validateParams, customOptions) => {
  try {
    const params = {
      resetUrl: resetUrl,
      password: await encryptData(password),//需要加密
      validateParams
    }
    const res = await useScrmFetch(`/api/gws-ext/customer/resetpwbyurl?endpoint=${domain}`, customOptions).post(params).json();

    const response = res?.data?.value
    if (response?.data?.customerResetByUrl?.customerUserErrors?.length) {
      const resultMsg = response?.data?.customerResetByUrl?.customerUserErrors[0].message
      useFailMsgBox(resultMsg)
      throw (new Error());
    } else if (res?.error && res?.error?.value) {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.resetPWFailPrompt,
      });
      throw (new Error());
    } else if (response?.errors?.length) {
      useFailMsgBox(response.errors[0].message)
      throw (new Error());
    } else if (response?.data?.customerResetByUrl) {
      return response?.data.customerResetByUrl;
    } else {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.resetPWFailPrompt,
      });
      throw (new Error());
    }
  } catch (e) {
    throw new Error(e);
  }
}

// 注册账后回调，通过验证码激活账号
export const customerActivateByUrl = async (activationUrl, password, validateParams, customOptions) => {
  try {
    const params = {
      activationUrl: activationUrl,
      password: await encryptData(password),//需要加密
      validateParams
    }
    const res = await useScrmFetch(`/api/gws-ext/customer/activate?endpoint=${domain}`, customOptions).post(params).json();
    //     res = {
    //     "resultCode": "ISC-000",
    //     "resultMsg": "",
    //     "data": {
    //         "extensions": {
    //             "cost": {
    //                 "requestedQueryCost": 13
    //             }
    //         },
    //         "data": {
    //             "customerActivateByUrl": {
    //                 "customerAccessToken": null,
    //                 "customerUserErrors": [
    //                     {
    //                         "field": null,
    //                         "message": "Customer already enabled"
    //                     }
    //                 ],
    //                 "customer": null
    //             }
    //         }
    //     }
    // }
    if (res?.error && res?.error?.value) {//
      window.igws.$toast.open({
        status: "error",
        text: customOptions.activationFailPrompt,
      });
      throw (new Error());
    }
    const response = res.data.value
    if (!response) {
      window.igws.$toast.open({
        status: "error",
        text: customOptions.activationFailPrompt,
      });
      throw (new Error(customOptions.activationFailPrompt));
    }

    if (response?.errors?.length) {
      const resultMsg = response?.errors[0].message
      useFailMsgBox(resultMsg);
      throw (new Error(resultMsg));
    } else if (response?.data?.customerActivateByUrl?.customerUserErrors?.length) {
      const resultMsg = response?.data?.customerActivateByUrl?.customerUserErrors[0].message
      if (response?.data?.customerActivateByUrl?.customerUserErrors[0].field === null) {
        useFailMsgBox(customOptions.activationRepeatPrompt);
      } else {
        useFailMsgBox(resultMsg);
      }
      throw (new Error(resultMsg));
    } else {
      return response?.data?.customerActivateByUrl;
    }
  } catch (e) {
    throw new Error(e);
  }
}

// 绑定B2B用户信息到购物车里
export const updateCartBuyerIdentity = async (buyerIdentity, cartId) => {
  try {
    const query = `      
    mutation updateCartBuyerIdentity($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
      cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
        cart {
          id
          checkoutUrl
          buyerIdentity {
            email
            phone
            customer {
              id
            }
            purchasingCompany {
              location {
                id
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      } 
    }
    `;
    const variables = {
      buyerIdentity: {
        ...buyerIdentity,
        countryCode: countryIsoCode
      },
      cartId,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 普通用户绑定公司信息到购物车里
export const updateCustomerCartBuyerIdentity = async (buyerIdentity, cartId) => {
  try {
    const query = `      
    mutation updateCartBuyerIdentity($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!${inContext}) {
      cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
        cart {
          id
          checkoutUrl
          buyerIdentity {
            email
            phone
            customer {
              id
            }
          }
        }
        userErrors {
          field
          message
        }
      } 
    }
    `;
    const variables = {
      buyerIdentity: {
        ...buyerIdentity,
        countryCode: countryIsoCode
      },
      cartId,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}


// 查询customer信息
// export const useFetchCustomer = async (accessToken) => {
//   try {
//     const query = `
//       query customer($customerAccessToken: String!){
//         customer(customerAccessToken: $customerAccessToken) {
//           ...CustomerFragment
//         }
//       }
//       ${customerFragment}
//     `;
//     const variables = {
//       customerAccessToken: accessToken
//     };
//     const response = await baseRequest(query, variables);

//     if (response?.errors) {
//       if (response?.errors?.[0]?.message) {
//         throw new Error(response.errors[0].message);
//       }

//       throw new Error('Unnable to fetch Customer');
//     }

//     return response?.customer;
//   } catch (e) {
//     console.error(e);
//   }
// }
export const useDeleteCustomerAccessToken = async (customerAccessToken) => {
  try {
    const query = `
      mutation customerAccessTokenDelete($customerAccessToken: String!) {
        customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
          deletedAccessToken
          userErrors {
            field
            message
          }
        }
      }
    `;
    const variables = {
      customerAccessToken
    };
    const response = await baseRequest(query, variables);

    if (response?.data?.customerAccessTokenDelete?.userErrors?.length) {
      const resultMsg = response?.data?.customerAccessTokenDelete?.userErrors[0].message
      useFailMsgBox(resultMsg);
      throw (new Error(resultMsg));
    }

    return response?.data.customerAccessTokenDelete;
  } catch (e) {
    throw new Error(e);
  }
}
